<visio-dialog [(showModal)]="isVisible" [okButton]="false">
  <ng-container slot="title">Formulário — {{ phaseName() || phaseId() }}</ng-container>

  <ng-container slot="body">
    @if (loading()) {
      <p class="loading-text">Carregando...</p>
    } @else {
      <form [formGroup]="form" class="phase-form">
        @for (field of formSchema(); track field.id) {
          <div class="field-group">
            <label [for]="field.id" class="field-label">
              {{ field.label }}
              @if (field.required) {
                <span class="required">*</span>
              }
            </label>

            @switch (field.type) {
              @case ('text') {
                <input
                  [id]="field.id"
                  type="text"
                  [formControlName]="field.id"
                  class="field-input"
                />
              }
              @case ('number') {
                <input
                  [id]="field.id"
                  type="number"
                  [formControlName]="field.id"
                  class="field-input"
                  (wheel)="blurOnWheel($event)"
                />
              }
              @case ('boolean') {
                <input
                  [id]="field.id"
                  type="checkbox"
                  [formControlName]="field.id"
                  class="field-checkbox"
                />
              }
              @case ('select') {
                <select [id]="field.id" [formControlName]="field.id" class="field-select">
                  <option value="" disabled>Selecione...</option>
                  @for (option of field.options; track option.value) {
                    <option [value]="option.value">{{ option.label }}</option>
                  }
                </select>
              }
              @case ('multiselect') {
                <div class="multiselect-group">
                  @for (option of field.options; track option.value) {
                    <label class="multiselect-option">
                      <input
                        type="checkbox"
                        [value]="option.value"
                        [checked]="isOptionChecked(field.id, option.value)"
                        (change)="onCheckboxChange($event, field.id)"
                      />
                      {{ option.label }}
                    </label>
                  }
                </div>
              }
            }
          </div>
        }
      </form>
    }
  </ng-container>

  <ng-container slot="cancel-btn">
    <visio-button (click)="isVisible.set(false)">Cancelar</visio-button>
  </ng-container>
  <ng-container slot="success-btn">
    <visio-button
      (click)="submit()"
      [disabled]="form.invalid || submitting() || loading()"
    >
      {{ submitting() ? 'Salvando...' : 'Salvar' }}
    </visio-button>
  </ng-container>
</visio-dialog>
